import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';

const FreeHTML = ({ content }) => <div dangerouslySetInnerHTML={{ __html: purifier(content, { ADD_TAGS: ['iframe', 'script', 'streamify-liveshopping'], KEEP_CONTENT: false }) }} />;

export default hot(module)(FreeHTML);
